import { render, staticRenderFns } from "./WorkDetail6.vue?vue&type=template&id=90cfa502&scoped=true&"
import script from "./WorkDetail6.vue?vue&type=script&lang=js&"
export * from "./WorkDetail6.vue?vue&type=script&lang=js&"
import style0 from "./WorkDetail6.vue?vue&type=style&index=0&id=90cfa502&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cfa502",
  null
  
)

export default component.exports